import React, { useEffect, useRef } from 'react';
import FaIcon from '../../../Elements/FaIcon';

export default function SettingsPane({
  anchorRef,
  aiModel,
  setAiModel,
  temperature,
  setTemperature,
  memory,
  setMemory,
  aiModelOptions,
  onClose,
}) {
  const ref = useRef(null);
  const isGpt5 = aiModel && aiModel.startsWith('gpt-5');

  useEffect(() => {
    const h = (e) => {
      const anchor = anchorRef && anchorRef.current;
      if (ref.current && !ref.current.contains(e.target) && !(anchor && anchor.contains(e.target))) {
        onClose();
      }
    };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, [anchorRef, onClose]);

  const anchor = anchorRef && anchorRef.current;
  const rect = anchor ? anchor.getBoundingClientRect() : { bottom: 80, right: window.innerWidth - 24 };
  const style = { top: rect.bottom + 8, right: window.innerWidth - rect.right };

  return (
    <div className='ac-setpop' ref={ref} style={style}>
      <div className='ac-set-head'>
        <span className='si'>
          <FaIcon iconName='fa-solid fa-cog' />
        </span>
        <h3>Chat Settings</h3>
      </div>
      <div className='ac-set-body'>
        <div className='ac-set-field'>
          <label>Model</label>
          <select value={aiModel} onChange={(e) => setAiModel(e.target.value)}>
            {aiModelOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <div className='ac-set-field'>
          <label>Response creativity</label>
          <input
            type='number'
            min={0}
            max={2}
            step={0.1}
            value={temperature}
            onChange={(e) => setTemperature(Math.max(0, Math.min(2, Number(e.target.value))))}
            disabled={isGpt5}
          />
          {isGpt5 ? <p className='ac-set-hint'>GPT-5 ignores creativity.</p> : null}
        </div>
        <div className='ac-set-field'>
          <label className='ac-set-check'>
            <input type='checkbox' checked={memory} onChange={(e) => setMemory(e.target.checked)} />
            Memory
          </label>
        </div>
      </div>
    </div>
  );
}
